import script from "./CheckAge.vue?vue&type=script&setup=true&lang=js"
export * from "./CheckAge.vue?vue&type=script&setup=true&lang=js"

import "./CheckAge.vue?vue&type=style&index=0&id=2d4bceda&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2d4bceda"]])

export default __exports__